module.exports = __webpack_public_path__ + "static/make-a-copy-b6a1ff49f90f410eaaee8c0ba68567da.png";